/**
 * FridayPrayer
 * Shows the current Jummah location, prayer times, map, and a device-friendly
 * directions link. Keep data in src/config/masjid.js so future venue changes
 * only need one update.
 */
import React from 'react';
import { MASJID } from '../../config/masjid';
import './style.css';

const getDirectionsUrl = () => {
  const { appleDirectionsUrl, googleDirectionsUrl } = MASJID.fridayPrayer;

  if (typeof navigator === 'undefined') return googleDirectionsUrl;

  const userAgent = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const isAppleDevice =
    /iPhone|iPad|iPod|Macintosh/i.test(userAgent) ||
    /Mac|iPhone|iPad|iPod/i.test(platform);

  return isAppleDevice ? appleDirectionsUrl : googleDirectionsUrl;
};

const FridayPrayer = () => {
  const friday = MASJID.fridayPrayer;

  return (
    <section className="friday-prayer-area section-padding">
      <div className="container">
        <div className="friday-prayer-title">
          <span>Friday Prayer</span>
          <h2>Join us for Jummah</h2>
          <p>
            Weekly Friday prayers are currently held at {friday.locationName}.
          </p>
        </div>

        <div className="row align-items-stretch">
          <div className="col-lg-5 col-md-12 col-12">
            <div className="friday-prayer-card">
              <span className="friday-prayer-label">Location</span>
              <h3>{friday.locationName}</h3>

              <ul className="friday-prayer-details">
                <li>
                  <span>Room</span>
                  <strong>{friday.room}</strong>
                </li>
                <li>
                  <span>Jummah</span>
                  <strong>{friday.jummah}</strong>
                </li>
                <li>
                  <span>Address</span>
                  <strong>{friday.address}</strong>
                </li>
              </ul>

              <a
                className="theme-btn friday-directions-btn"
                href={getDirectionsUrl()}
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Directions
              </a>
            </div>
          </div>

          <div className="col-lg-7 col-md-12 col-12">
            <div className="friday-prayer-map">
              <iframe
                title={`${friday.locationName} map`}
                src={friday.mapEmbedUrl}
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FridayPrayer;
